import React from "react";
import { NumericFormat } from "react-number-format";

export default function SavingsCard({ icon, title, value, width, type, color }) {
  const words = title.split(" ");
  const isLongTitle = words.length > 3;

  return (
    <div
      className={` w-[320px] h-[100px] flex gap-5 justify-center items-center rounded-[30px]`}
      style={{ background: color }}
    >
      <img src={icon} alt="image" className="w-[50px] h-[50px]" />
      <div className="text-white text-lg font-normal">
        <p className="text-2xl font-bold">
          <NumericFormat
            displayType="text"
            value={value}
            thousandSeparator={true}
            decimalScale={2}
            prefix={type === "COST" ? "$ " : ""}
          />
        </p>
        {isLongTitle ? (
          <>
            <p className="text-base font-normal">{words.slice(0, 3).join(" ")}</p>
            <p className="text-base font-normal">{words.slice(3).join(" ")}</p>
          </>
        ) : (
          <p className="text-base font-normal">{title}</p>
        )}
      </div>
    </div>
  );
}
